module.exports = __webpack_public_path__ + "img/tom.eca44f66.svg";